'use client';

import { createContext } from 'react';

import type { TagRootContextInterface } from '../types/tag-root.types';

export const TagRootContext = createContext<TagRootContextInterface>({});

TagRootContext.displayName = 'Tag.Root.Context';
